import React from 'react';
import Paper from '@material-ui/core/Paper';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import get from 'lodash/get';
import GridPopover from './GridPopover';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: {
    padding: '0px',
    margin: '0px'
  }
});

/**Allow to display a list of information from a field in grid, the list will be displayed as a grid within a popover window */
export default function PopupField(props) {
  const { classes: classesOverride } = props;
  const classes = useStyles({ classes: classesOverride });
  const { data = [], label, optionText, headLabel, classesNames = {} } = props;
  return (
    <GridPopover
      text={label}
      classes={{ button: classes.button }}
      popoverContent={
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{headLabel}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => {
                return (
                  <TableRow key={index} className={classesNames.tableRow}>
                    <TableCell className={classesNames.tableCell}>
                      {optionText ? get(item, optionText) : item}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      }
    />
  );
}
